import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';

export default class BambooHrApiLogSearchParams extends SearchParamsBase {
  initialize() {
    this.Id = '';
    this.Type = '';
    this.Result = '';
    this.UseDateRange = false;
    this.StartDate = dateTimeHelper.indefiniteDateValue();
    this.EndDate = dateTimeHelper.indefiniteDateValue();
  }

  //-------------------------------------------
  //-------- Fields for Search Panel ----------
  //-------------------------------------------

  static fieldsInSearchBox = [
    { fieldName: 'Id', label: 'Id', className: 'col-4', type: InputTypesEnum.Number },
    {
      fieldName: 'Type',
      label: 'Type',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: BambooHrApiLogSearchParams.getOptionsForTypes(),
    },
    { fieldName: 'Result', label: 'Result', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'UseDateRange', label: 'Date Range', className: 'col-4', type: InputTypesEnum.OnOff },
    {
      fieldName: 'StartDate',
      label: 'Start Date',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDateRange,
    },
    {
      fieldName: 'EndDate',
      label: 'End Date',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDateRange,
    },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'BambooHrApiLogSearchParams';

  //---------------------------

  static getOptionsForTypes() {
    return [
      { label: 'Choose one...', value: '', disabled: true },
      {
        label: 'CalculateAverageEmployeeCostFunctionService',
        value: 'CalculateAverageEmployeeCostFunctionService',
        disabled: false,
      },
      { label: 'CalculateTimesheetEntryValues', value: 'CalculateTimesheetEntryValues', disabled: false },
      { label: 'GetEmployeeWorkingHours', value: 'GetEmployeeWorkingHours', disabled: false },
      { label: 'GetEmployeeDirectory', value: 'GetEmployeeDirectory', disabled: false },
      { label: 'SendTimesheetNotificationEmail', value: 'SendTimesheetNotificationEmail', disabled: false },
      { label: 'CreatePtoTimesheetEntries', value: 'CreatePtoTimesheetEntries', disabled: false },
      { label: 'XE Import', value: 'XE Import', disabled: false },
      { label: 'XE SAP', value: 'XE SAP', disabled: false },
      { label: 'CalculateAllPricingFeesService', value: 'CalculateAllPricingFeesService', disabled: false },
      { label: 'Missed Invoices Notification', value: 'MissedInvoicesNotification', disabled: false },
      { label: 'Excel Data Export', value: 'ExcelDataExport', disabled: false },
      { label: 'Excel Data Export Queue', value: 'ExcelDataExportQueue', disabled: false },
      { label: 'WorklogImportQueueTrigger', value: 'WorklogImportQueueTrigger', disabled: false },
      {
        label: 'GetPtosForVacationPlanningFunctionService',
        value: 'GetPtosForVacationPlanningFunctionService',
        disabled: false,
      },
      { label: 'ClientOptionExportTimerTrigger', value: 'ClientOptionExportTimerTrigger', disabled: false },
      { label: 'WorklogImportHttpTrigger', value: 'WorklogImportHttpTrigger', disabled: false },
      { label: 'Anti Fraud Tool', value: 'Anti Fraud Tool', disabled: false },
      { label: 'WorklogImportTimerTrigger', value: 'WorklogImportTimerTrigger', disabled: false },
    ];
  }
}
